import {
  AWS_AUTH_DOMAIN,
  AWS_COGNITO_USERPOOL_CLIENT_ID,
  AWS_COGNITO_USERPOOL_ID,
  AWS_REGION,
  HOSTNAME,
} from 'src/utils/env'
import { BASE_PATH, SIGN_IN } from 'src/utils/routes'

const ROOT_URL = HOSTNAME ? `https://${HOSTNAME}` : 'http://localhost:8585'
// see: https://docs.amplify.aws/lib/client-configuration/configuring-amplify-categories/q/platform/js
export const configure = {
  Auth: {
    region: AWS_REGION,
    userPoolId: AWS_COGNITO_USERPOOL_ID,
    userPoolWebClientId: AWS_COGNITO_USERPOOL_CLIENT_ID,
    mandatorySignIn: true,
    oauth: {
      domain: AWS_AUTH_DOMAIN,
      scope: ['profile', 'openid'],
      redirectSignIn: `${ROOT_URL}${BASE_PATH}${SIGN_IN}`,
      redirectSignOut: ROOT_URL,
      clientId: AWS_COGNITO_USERPOOL_CLIENT_ID,
      responseType: 'code',
    },
  },
} as const
